import React, { useState, useEffect, useRef } from "react";

import TableWrapper from "../../components/table/reactTable";
import styled from "styled-components";
import ContentHeader from "../../components/header/contentHeader";
import { TableButton, AddButton } from "../../components/buttons";
import { useParams } from "react-router";
import DB from "../../DB/firebase";
import { Row, Col, Modal, Form, Select, Button, Upload } from "antd";
import { InputWrapper } from "../../components/input";
import cogoToast from "cogo-toast";
import { Link } from "react-router-dom";

const StyledContent = styled.div`
  .form-label {
    text-align: left;
    margin-bottom: 8px;
    font-size: 16px;
  }
`;

const PriceDetails = () => {
  const { id, category, index } = useParams();
  const [values, setValues] = useState([]);
  const [pricesData, setPricesData] = useState([]);
  const [completeData, setCompleteData] = useState([]);
  const [togglePriceModal, setTogglePriceModal] = useState(false);
  const [priceIndex, setPriceIndex] = useState(null);
  const [modalType, setModalType] = useState("");

  const [currentPrice, setCurrentPrice] = useState({
    name: "",
    Time: 0,
    Value: 0,
    type: "",
  });

  const [priceForm] = Form.useForm();

  const handleChangePrice = (e) => {
    const { name, value } = e.target;
    setCurrentPrice({ ...currentPrice, [name]: value });
  };

  const handlePriceForm = async () => {
    let data = { ...completeData };
    if (modalType == "ADD") {
      console.log(currentPrice);
      let c = [];
      let vvv = values.length ? values : [{}];
      if (vvv.length)
        c = vvv.map((val, Index) => {
          return {
            Time: 0,
            Value: 0,
            name: val,
            title: currentPrice.type,
            Index: pricesData.length,
          };
        });
      console.log("cc", c);
      let a = { ...currentPrice };
      a[currentPrice.type] = c;
      delete a.type;
      console.log("ss", a);
      debugger;
      data.subServices[index].Price.push({ ...a });
    } else if (modalType == "EDIT") {
      let c = [];

      if (values.length)
        c = values.map((val, Index) => {
          return {
            Time: 0,
            Value: 0,
            name: val,
            title: currentPrice.type,
            Index: priceIndex,
          };
        });

      let a = { ...currentPrice };

      a[currentPrice.type] = c;
      delete a.type;
      data.subServices[index].Price[priceIndex].name = currentPrice.name;
      data.subServices[index].Price[priceIndex][currentPrice.type] = c;
    }
    console.log(priceIndex, "sss", data);
    await DB.firestore().collection(category).doc(id).set(data, { merge: true });
    fetch();

    setTogglePriceModal(false);

    cogoToast.success("price added successfully");

    // console.log("prices data",pricesData[priceIndex])
  };

  const modalHandler = (index) => {
    setTogglePriceModal(true);
    setPriceIndex(index);
    let data = pricesData[index];
    console.log("ss", data);
    let obj = Object.keys(data);
    let filter = obj.filter((val) => val !== "Time" && val !== "Value" && val !== "name");
    let values = data[filter[0]].map((val) => val.name);
    console.log("jannat", { ...data, type: filter[0] });
    setCurrentPrice({ ...data, type: filter[0] });
    setValues(values);

    priceForm.setFieldsValue({
      Name: data?.name,
      Value: currentPrice?.Value,
      Time: currentPrice?.Time,
      values: values,
      type: filter[0],
    });
  };

  const deleteHandler = (priceIndex) => {
    let data = { ...completeData };
    data.subServices[index].Price.splice(priceIndex, 1);
    DB.firestore().collection(category).doc(id).set(data, { merge: true });

    cogoToast.success("deleted successfully");
  };

  useEffect(() => {
    fetch();
  }, []);
  const fetch = () => {
    DB.firestore()
      .collection(category)
      .doc(id)
      .onSnapshot((resp) => {
        console.log("sss", resp.data());
        setPricesData(resp.data().subServices[index].Price);
        setCompleteData(resp.data());
      });
  };
  return (
    <>
      <div>
        <ContentHeader title={`prices`} />
        <AddButton
          onClick={() => {
            console.log("working add");
            setTogglePriceModal(true);

            setCurrentPrice({
              ...currentPrice,
              name: "",
              Value: 0,
              Time: 0,
              type: "",
            });

            priceForm.setFieldsValue({
              Name: "",
              Value: 0,
              Time: 0,
              type: "",
              values: [],
            });
            setValues([]);
            setModalType("ADD");
          }}
          style={{ float: "right", margin: "12px 0" }}
        >
          + Add New
        </AddButton>
        {togglePriceModal && (
          <Modal
            title={"Add price,color and sizes"}
            visible={togglePriceModal}
            onCancel={() => {
              setTogglePriceModal(false);
            }}
            footer={null}
            centered
          >
            <StyledContent>
              <Form
                form={priceForm}
                id="Add_SubService"
                onFinish={handlePriceForm}
                validateTrigger="onFinish"
              >
                <Row justify="space-between">
                  <Col span={11}>
                    <h4 className="form-label">*Name</h4>
                    <Form.Item name="Name" rules={[{ required: true, max: 20 }]}>
                      <InputWrapper
                        maxLength={20}
                        name="name"
                        placeholder="Service Name"
                        value={currentPrice?.name}
                        onChange={handleChangePrice}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={11}>
                    <h4 className="form-label">*Type</h4>
                    <Form.Item name="type" rules={[{ required: true }]}>
                      <InputWrapper
                        name="type"
                        disabled={modalType == "EDIT" ? true : false}
                        placeholder="Type"
                        value={currentPrice?.type}
                        onChange={handleChangePrice}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={11}>
                    <h4 className="form-label">*Values</h4>
                    <Form.Item name="values" rules={[{ required: true }]}>
                      <Select
                        mode="tags"
                        style={{ width: "100%", paddingBottom: 10 }}
                        placeholder="Add Values"
                        onChange={(e) => {
                          console.log("sss", e);
                          setValues(e);
                        }}
                        value={values}
                      ></Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row justify="end" align="middle">
                  <Col span={7} style={{ paddingLeft: "10px" }}>
                    <Button
                      block
                      shape="round"
                      type="danger"
                      size="default"
                      onClick={() => {
                        setTogglePriceModal(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </Col>
                  <Col span={7} style={{ paddingLeft: "10px" }}>
                    <Button
                      block
                      shape="round"
                      type="primary"
                      size="default"
                      style={{
                        outline: "none",
                        border: "none",
                        backgroundColor: "#49D3CE",
                      }}
                      htmlType="submit"
                    >
                      {"Ok"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </StyledContent>
          </Modal>
        )}
        <TableWrapper
          tableData={pricesData.length ? pricesData : []}
          showPagination={true}
          columns={[
            {
              Header: "Price Name",
              accessor: "name",
              sortable: false,
              Cell: (r) => {
                return <p>{r.original.name}</p>;
              },
            },
            {
              Header: "Time",
              accessor: "name",
              sortable: false,
              Cell: (r) => {
                return <p>{r.original.Time}</p>;
              },
            },
            {
              Header: "Value",
              accessor: "name",
              sortable: false,
              Cell: (r) => {
                return <p>{r.original.Value}</p>;
              },
            },
            {
              Header: "Type",
              accessor: "name",
              sortable: false,
              Cell: (r) => {
                let obj = Object.keys(r.original);
                let filter = obj.filter(
                  (val) => val !== "Time" && val !== "Value" && val !== "name"
                );
                let name = [];
                console.log(r.original, "darshan");
                if (filter.length) name = r.original[filter[0]].map((val) => val.name);
                return (
                  <p>
                    {filter.length > 0 && <b>{filter[0] + "->"}</b>} {name.join(",")}{" "}
                  </p>
                );
              },
            },

            {
              Header: "Package Type",
              accessor: "name",
              sortable: false,
              Cell: (r) => {
                return (
                  <>
                    <Button
                      type="primary"
                      disabled={r.index === 0 ? true : false}
                      onClick={() => {
                        setModalType("EDIT");
                        modalHandler(r.index);
                      }}
                    >
                      EDIT
                    </Button>
                    <Button
                      disabled={r.index === 0 ? true : false}
                      type="danger"
                      onClick={() => {
                        deleteHandler(r.index);
                      }}
                    >
                      DELETE
                    </Button>
                  </>
                );
              },
            },
          ]}
        />
      </div>
    </>
  );
};

export default PriceDetails;

const StyledActionContent = styled.div`
  p {
    color: #1d194d;
    cursor: pointer;
    margin: 4px 0;
    :hover {
      text-decoration: underline;
      color: #393385;
    }
  }
`;
